var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPauseIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 45,
  height: 44,
  viewBox: "0 0 45 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.7344 30.7654H29.1171V13.2346H24.7344V30.7654ZM15.8828 30.7654H20.2655V13.2346H15.8828V30.7654ZM44.5 22C44.5 28.072 42.3519 33.2577 38.0556 37.554C33.7577 41.8518 28.5736 44 22.5 44C16.428 44 11.2423 41.8518 6.946 37.554C2.64971 33.2577 0.5 28.072 0.5 22C0.5 15.9264 2.64971 10.7423 6.946 6.44443C11.2423 2.14814 16.428 0 22.5 0C28.5736 0 33.7577 2.14814 38.0556 6.44443C42.3519 10.7423 44.5 15.9264 44.5 22Z",
  fill: "#4585FF"
})));
export default SvgPauseIcon;